import { getCurrentAuthUser } from '../lib/cognitoAuth';

const CACHE_MS = 5 * 60 * 1000;
let cache = { at: 0, headers: {} };

/**
 * Headers para que Gen 2 (IAM) sepa quién guardó, no el rol de Cognito Identity.
 */
export async function auditCallerHeaders() {
  if (Date.now() - cache.at < CACHE_MS && cache.headers['x-nua-username']) {
    return cache.headers;
  }
  try {
    const current = await getCurrentAuthUser();
    const attributes = current?.attributes || {};
    const username = String(
      attributes.email ||
        attributes.preferred_username ||
        current?.user?.username ||
        '',
    ).trim();
    const userSub = String(current?.user?.userId || '').trim();
    const headers = {};
    if (username) headers['x-nua-username'] = username;
    if (userSub) headers['x-nua-user-sub'] = userSub;
    cache = { at: Date.now(), headers };
    return headers;
  } catch {
    return {};
  }
}

export function resetAuditCallerHeadersCache() {
  cache = { at: 0, headers: {} };
}
